import { Component, effect, OnInit, signal } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { ConfirmationService, MessageService } from 'primeng/api';

import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from 'primeng/dynamicdialog';

import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { take } from 'rxjs';
import { Segnalazione_Firestore } from 'src/app/models/firestore/segnalazioneFirestore.model';
import { SegnalazioniService } from 'src/app/services/segnalazioni.service';
import { Segnalazione } from 'src/app/models/segnalazione.model';
import { UserService } from 'src/app/services/user.service';
import { StatoSegnalazione } from 'src/app/models/stato.segnalazione.model';

@Component({
  selector: 'app-prendi_in_carico-segnalazione',
  templateUrl: './prendi_in_carico-segnalazione.component.html',
  styleUrls: ['../segnalazioni.component.css'],
})
export class PrendInCaricoSegnalazioneComponent implements OnInit {
  priorities = [
    { label: 'Bassa', value: 'BASSA' },
    { label: 'Media', value: 'MEDIA' },
    { label: 'Alta', value: 'ALTA' },
    { label: 'Critica', value: 'CRITICA' },
  ];

  protected segnalazione: Segnalazione_Firestore;
  protected prendiInCaricoSegnalazioneForm: FormGroup;

  protected ref: DynamicDialogRef;
  isSaving = signal(false);

  constructor(
    private logger: NGXLogger,
    public dialogRef: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public segnalazioniService: SegnalazioniService,
    public confirmationService: ConfirmationService,
    private messageService: MessageService,
    public dialogService: DialogService,
    private _formBuilder: FormBuilder,
    private utentiService: UserService,
  ) {

    effect(() => {
      const isSaving = this.isSaving();
      this.config.closable = !isSaving;
      this.config.closeOnEscape = !isSaving;
    });
  }

  getPriorityIcon(priority: string): string {
    switch (priority) {
      case 'BASSA':
        return 'pi pi-check-circle green';
      case 'MEDIA':
        return 'pi pi-exclamation-circle yellow';
      case 'ALTA':
        return 'pi pi-exclamation-triangle orange';
      case 'CRITICA':
        return 'pi pi-times-circle red';
      default:
        return '';
    }
  }

  ngOnInit(): void {
    this.segnalazione = this.config.data.segnalazione;

    this.prendiInCaricoSegnalazioneForm = this._formBuilder.group({
      priorita: new FormControl(
        { value: null, disabled: false },
        Validators.required,
      ),
    });
  }

  conferma(conferma: boolean) {
    if (!conferma) {
      this.dialogRef.close({ success: false });
    } else {
      this.isSaving.set(true);
      this.prendiInCaricoSegnalazioneForm.disable();
      let segnalazioneDaModificare = new Segnalazione();
      let nuovoStatoSegnalazione = new StatoSegnalazione();
      nuovoStatoSegnalazione.id = 2;
      segnalazioneDaModificare.id = this.segnalazione.id;
      segnalazioneDaModificare.autore = this.utentiService.getUser();
      segnalazioneDaModificare.operatoreInCarico = this.utentiService.getUser();
      if (this.segnalazione.stato !== 'PIANIFICATA') {
        segnalazioneDaModificare.stato = nuovoStatoSegnalazione;
      }
      //segnalazioneDaModificare.stato = nuovoStatoSegnalazione;
      segnalazioneDaModificare.priorita =
        this.prendiInCaricoSegnalazioneForm.value.priorita.value.toUpperCase();
      this.segnalazioniService.modifica(segnalazioneDaModificare)
      .pipe(take(1))
      .subscribe({
        error: (e) => {
          this.isSaving.set(false);
          this.messageService.add({
            severity: 'info',
            summary: 'Errore',
            life: 10000,
            detail: 'Errore in fase di presa in carico della segnalazione',
          });
          this.dialogRef.close({
            success: false,
          });
        },
        complete: () => {
          this.isSaving.set(false);

          this.dialogRef.close({
            success: true,
          });
        },
      });
    }
  }
}
